var _defs, _rect, _rect2, _rect3, _path, _rect4, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#013177;}.cls-3{fill:#00a4e3;}.cls-4{fill:#33c3ef;}.cls-5{fill:#074ea3;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.47,
    y: 44.69,
    width: 68.68,
    height: 51.32,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.51,
    y: 58.31,
    width: 49.4,
    height: 37.71,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.01,
    y: 70.49,
    width: 36.41,
    height: 25.57,
    rx: 1.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.11,96.06H62.25V87.75H80.42A8.31,8.31,0,0,1,72.11,96.06Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.04,
    y: 78.74,
    width: 18.17,
    height: 8.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.38,78.8H62.21V70.49h9.86a8.31,8.31,0,0,1,8.31,8.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.57,50.21l-4.84-10a1,1,0,0,0-.58-.51L61.36,27a1,1,0,0,0-.67,0L25.45,39.72a1,1,0,0,0-.54.46l-5.46,10a1,1,0,0,0,.89,1.49h82.33a1,1,0,0,0,.9-1.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.57,50.21l-4.84-10a1,1,0,0,0-.91-.56h-72a1,1,0,0,0-.89.52l-5.46,10a1,1,0,0,0,.89,1.49h82.33a1,1,0,0,0,.9-1.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco1);
export default __webpack_public_path__ + "static/media/ico1.66984170df0679ec3b8a525d875074eb.svg";
export { ForwardRef as ReactComponent };